<style>

h3{
  text-align: center;
}

.space{
  margin: 20px;
  overflow-wrap: break-word;
}

.block{
  /* font-style: italic; */
  font-weight: bold;
  margin-left: 40px;
}

</style>

<Auth bind:this="{auth}"></Auth>
<Profile bind:this="{profile}" bind:me="{me}"></Profile>

{#if show}

  <h3>Send Invite Code</h3>

  {#if code == ""}
    
    <div class="space">
      <button on:click="{generate}">Generate Code</button>
    </div>
    
    <div class="space small">Use the button above to get a new invite code.</div>
    <div class="space small">Only one friend can use an invite code.</div>
    
  {:else if code != ""}

    <div class="space">Your invite code has been generated.</div>

    <div class="space block">Hey, I'm inviting you to a new app named Hanging Out Today (HOT). It helps you find new friends and do things together.<br><br>https://hangingout.today/invited.html?code={code}</div>

    <div class="space">
      <button on:click="{copy}">{copyText}</button>
    </div>
    
    <div class="space">Once copied, paste and send this message to a friend.</div>
    
  {/if}
  
{/if}

<script>

import { createEventDispatcher } from 'svelte';
const dispatch = createEventDispatcher();

import Auth from "../../interfaces/Auth.svelte";
let auth;

import Profile from "../../interfaces/Profile.svelte";
let profile;

import Validate from "../../helpers/Validate.js";
import Normalize from "../../helpers/Normalize.js";

export let show = false;
export let me = null;

let code = "";
let copyText = "Copy Text";

async function generate() {
  
  code = await auth.post("genInviteCode");
  dispatch("genInviteCode");
  
}


// from https://stackoverflow.com/a/33946647
function copy() {
  
  let text = `Hey, I'm inviting you to a new app named Hanging Out Today (HOT). It helps you find new friends and do things together. https://hangingout.today/invited.html?code=${code}`;
  
  // Create a dummy input to copy the string array inside it
  var dummy = document.createElement("input");

  // Add it to the document
  document.body.appendChild(dummy);

  // Set its ID
  dummy.setAttribute("id", "dummy_id");

  // Output the array into it
  document.getElementById("dummy_id").value = text;

  // Select it
  dummy.select();

  // Copy its contents
  document.execCommand("copy");

  // Remove it as its not needed anymore
  document.body.removeChild(dummy);
  
  copyText = "Copied!";
  
  setTimeout( () => { code = ""; copyText = "Copy Text"; dispatch("codeCopied"); }, 2000);
}

</script>